<template>
    <div
        class="limit"
        :class="styleConfigContainer()">
        <BaseMap class="map"
            v-if="(!data.address.disabledMap && showLocation)"
            :startPopupOn="true"
            :zoom="15"
            :zoomControl="false"
            :addressLatLng="data.address.latLon"
            @markerIsInvalid="showLocation=!$event">

            <template #boxPopup><div>
                <ContactInfo
                    :address="data.address"
                    :telephones="data.telephones"
                    :socials="socials"
                />
            </div></template>
        </BaseMap>

        <div
            class="m-auto shadow p-3 mb-5 rounded"
            :class="styleConfigForm()"
        >
            <form role="form" :class="navbarPosition ? 'mt-8':''">
                <div class="text-center mx-md-auto page-center pt-2">
                    <h2 class="info--text">{{ $t('support.support_form') }}</h2>
                </div>

                <select
                    name="subject"
                    v-model="subject"
                    v-validate="'required'"
                    :class=" {'input': true, 'is-invalid': errors.has('subject') }"
                    class="pa-1 col-12 mb-4 form-control"
                >
                    <option value disabled selected hidden>{{ $t('support.tickets.department') }}</option>
                    <option
                        selected
                        v-for="(label, i) in settings.labels"
                        :key="i"
                        :value="label.translation.name"
                    >{{ label.translation.name }}</option>
                </select>
                <span
                    v-show="errors.has('subject')"
                    class="invalid-feedback"
                >{{ errors.first($t('support.subject')) }}</span>

                <AddressForm
                    class="px-3"
                    v-if="settings.form.enable_addresses"
                    ref="address_form"
                    v-model="address"
                />

                <FormBuilder ref="form_builder" v-model="settings.form" />

                <Captcha ref="captcha" />
                <div class="text-center">
                    <button
                        @click="submit"
                        type="submit"
                        :loading="loading"
                        :style="$bgColor(color.primary)"
                        class="btn btn-primary my-4"
                    >{{ $t('support.submit') }}</button>
                </div>
            </form>
        </div>

         <div v-if="data.address.disabledMap" class="col-lg-4 col-12 mb-3 ml-lg-4 contact-info shadow">
            <ContactInfo
                :address="data.address"
                :telephones="data.telephones"
                :socials="socials"
            />
        </div>

    </div>
</template>

<script>
import BaseButton from "../../../js/argon/components/BaseButton";
import FormBuilder from "../FormBuilderComponents/FormBuilder";
import TextField from "../../../../../resources/js/components/FormBuilder/Fields/Layouts/Admin/FbTextField";
import SelectFieldForm from "../FormBuilderComponents/ContentComponents/SelectFieldForm";
import Captcha from "../Common/Captcha";
import AddressForm from "../FormBuilderComponents/ContentComponents/AddressForm";
import BaseMap from "../../argon/components/Map/BaseMap";
import { address } from '../../../../../resources/js/components/FormBuilder/Fields/Fields';
import ContactInfo from './ContactInfo';

export default {
    name: "SupportEmailFormBuilder",
    components: {
        SelectFieldForm,
        TextField,
        FormBuilder,
        BaseButton,
        Captcha,
        AddressForm,
        BaseMap,
        ContactInfo
    },

    data() {
        return {
            settings: {
                ...this.data.settings
            },
            model: false,
            subject: "",
            loading: false,
            address: {
                location: {
                    zip: "",
                    address: "",
                    number: "",
                    neighborhood: "",
                    country: "",
                    state: "",
                    city: "",
                    info: "",
                    code: "BR"
                }
            },
            showLocation: true
        };
    },

    props: {
        data: {
            type: Object
        },
        socials: {
            type: Array
        }
    },

    methods: {
        setAddress(){
            this.settings.form.address = {...this.address.location};
        },
        async submit(e) {
            e.preventDefault();
            const captcha = await this.$refs.captcha.send();
            await this.$store.commit("VALIDATE", true);

            let hasFormInvalid = await this.$refs.form_builder.$validator.validate().then(validFormBuilder => validFormBuilder);
            hasFormInvalid = this.settings.form.enable_addresses && hasFormInvalid ? await this.$refs.address_form.$validator.validate().then(validAddress => validAddress) : hasFormInvalid;

            await this.$validator.validateAll().then(async valid => {
                if (valid && captcha && hasFormInvalid ) {
                    this.loading = true;
                    if(this.settings.form.enable_addresses){
                        this.setAddress();
                    }
                    window.axios
                        .post("/api/support/email/submit", {
                            ...this.settings,
                            subject: this.subject
                        })
                        .then(res => {
                            this.$notify({
                                type: "success",
                                message: res.data.message
                            });

                            this.loading = false;
                        })
                        .catch(err => {
                            this.$notify({
                                type: "danger",
                                message: this.$t('err.response.data.err')
                            });
                            this.loading = false;
                        });
                }
            });
            this.$store.commit("VALIDATE", false);
        },

        hasDisableLabels(){
            if(this.settings && this.settings.labels.length){
                const activeLabels = this.settings.labels.filter(label => label.status);
                this.settings.labels = activeLabels;
            }
        },

        styleConfigContainer(){
            if(this.data.address.disabledMap && this.showLocation){
                return {
                    container: true,
                    'd-flex': true,
                    'flex-lg-row': true,
                    'flex-column-reverse': true
                }
            }
        },

        styleConfigForm(){
            let styles = {};
            if(this.showLocation && !this.data.address.disabledMap){
                styles = {
                    ...styles,
                    'style-form': true,
                    'col-lg-5': true,
                    'scroll-form':true
                }
            }if(!this.showLocation) {
                styles = {
                    ...styles,
                    container: true
                }
            }if(this.data.address.disabledMap){
                styles = {
                    ...styles,
                    'col-lg-8': true,
                    'col-12': true
                }
            }
            return styles;
        },


    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        navbarPosition() {
            return this.$store.getters.NAVBAR_FIXED;
        }
    },

    mounted(){
        this.hasDisableLabels();
    }
};
</script>

<style scoped>

.map{
    height: 312px;
}

.contact-info{
    background: white;
    height: 100%;
    border-radius: 10px;
    margin-top: 40px;
}

.scroll-form{
    height: 850px;
    overflow: auto;
}

@media (min-width: 992px){
    .limit{
        position: relative;
    }
    .map{
        position: relative;
        height: 900px;
        z-index: 0;
    }
    .style-form{
        background-color: #f8f9fe;

        position: absolute;
        top: 20px;
        left: 70px;
        z-index: 1;
    }
}

@media (min-height: 901px) and (min-width: 992px){
    .map{
        height: 100vh;
    }
}
</style>
